export default {
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  discoveryDocs:
    ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  spreadsheetId: "1UaJB6GqmCOJ9mAaNzEark9Of4AIb7wTx346E7gNlhGE"
};
